import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import './index.css'
import InputBase from '@material-ui/core/InputBase';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: '-2px',
      backgroundColor: 'var(--cor-tema)',
      transitionDuration: '0.4s',
      color: 'var(--cor-placeholder)'

    },
    'label + &.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      backgroundColor: 'var(--cor-tema)',
      transitionDuration: '0.4s',
    },
  },

  input: {
    borderRadius: '4px',
    position: 'relative',
    backgroundColor: 'var(--cor-tema)',
    transitionDuration: '0.4s',
    color: 'var(--cor-fonte-hover)',
    border: '1px solid #083c7c',
    // fontSize: '0.9rem',
    // padding: '10px 26px 10px 12px',
    height: '15px',
    marginTop: '2px',
    paddingLeft: '10px',
    '.MuiInputBase-root:hover &:disabled': {
      border: '1px solidrgb(29, 75, 130)',
      borderRadius: '4px',
      transition: 'none',
      height: '15px',
    },
    '&:focus': {
      borderRadius: '4px',
      borderColor: '#083c7c',
      borderWidth: '2px',
      backgroundColor: 'var(--cor-tema)',
      transitionDuration: '0.4s',
      height: '13px',
      paddingTop: '5px',
      paddingLeft: '9px'
    },
    '&.Mui-disabled': {
      border: '1px solid #083c7c',
      color: 'var(--cor-fonte-hover)',
      '&:hover': {
        borderColor: '#083c7c',
        borderRadius: '4px',
      },
    },

  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  margin: {
    marginRight: '6px',
    marginBottom: '10px'
  },

  label: {
    margin: theme.spacing(-1.5),
    marginLeft: theme.spacing(1.5),
    backgroundColor: 'var(--cor-tema)',
    transitionDuration: '0.4s',
    // color: 'var(--cor-fonte-hover)',
    zIndex: 3,
    top: '-3px',
    color: 'var(--cor-placeholder)',
    '&.MuiInputLabel-shrink': {
      padding: '5px',
      top: '0',
      color: 'var(--cor-placeholder)',
      backgroundColor: 'var(--cor-tema)',
      transitionDuration: '0.4s',
    },

  },

}));

export default function CustomizedSelects(props) {
  const classes = useStyles();
  const corTema = document.documentElement.style.getPropertyValue('--cor-tema')
  return (
    <>
      <FormControl className={classes.margin} style={props.style}>
        <InputLabel htmlFor="demo-customized-select-native" className={classes.label} disabled={props.disabled} hidden={props.hidden}>{props.label}</InputLabel>
        <NativeSelect
          id={props.id}
          value={props.value}
          onChange={props.handleChange}
          name={props.name}
          input={<BootstrapInput />}
          {...props}
        >
          {/* <MenuItem aria-labelledby='Nenhum' value="">{''} </MenuItem> */}
          <option value={props.mostraTodos ? -1 : ''} style={{ backgroundColor: corTema }}>{props.mostraTodos ? 'Todos' : ''}</option>
          {
            props.data?.map((item, key) => {
              return (<option value={item.value} style={{ backgroundColor: corTema }} key={item.value}> {item.display} </option>)
            })

          }

        </NativeSelect>
      </FormControl>
    </>
  );
}